'use client';

import { c as _c } from "react/compiler-runtime";
import { HeroUIProvider } from '@heroui/react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import type { ReactNode } from 'react';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/lib/providers/auth-provider';
import ConfirmProvider from '@/lib/providers/confirm';
import { LastVisitedRouteProvider } from '@/lib/providers/last-visited-route-provider';
import { TanstackQueryClientProvider } from '@/lib/providers/tanstack-query/query-client-provider';
import { TutorialChatProvider } from '@/lib/providers/tutorial-chat-provider';
import { env } from '@/shared/constants/env-variables';
export default function Providers(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      limitUrlUpdates: {
        method: "debounce",
        timeMs: env.NEXT_PUBLIC_DEFAULT_DEBOUNCE_IN_MS
      },
      shallow: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Toaster richColors={true} position="top-center" swipeDirections={["bottom", "left", "right", "top"]} theme="light" className="cursor-grab select-none" closeButton={true} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <TanstackQueryClientProvider><AuthProvider><LastVisitedRouteProvider><HeroUIProvider locale="pt-BR"><ConfirmProvider><NuqsAdapter defaultOptions={t1}>{t2}<TutorialChatProvider>{children}</TutorialChatProvider></NuqsAdapter></ConfirmProvider></HeroUIProvider></LastVisitedRouteProvider></AuthProvider></TanstackQueryClientProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}